// This function retrieves the AI team settings from local storage.

/**
 * @property {Object} currentSettings - The current settings of the team.
 * @property {string} fallbackLogo - The default logo for the AI bot.
 */
function getTeamAiBotLogo(currentSettings, fallbackLogo) {
  const defaultLogo = fallbackLogo || 'img/icons/ai.svg';
  if (currentSettings && currentSettings.isEnabled) {
    return currentSettings?.aiLogoUrl || defaultLogo;
  } else {
    return defaultLogo;
  }
}

export { getTeamAiBotLogo };
